import { render, staticRenderFns } from "./BookDealCapture.vue?vue&type=template&id=6bda8f5e&scoped=true"
import script from "./BookDealCapture.vue?vue&type=script&lang=js"
export * from "./BookDealCapture.vue?vue&type=script&lang=js"
import "./BookDealCapture.vue?vue&type=style&index=0&id=6bda8f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda8f5e",
  null
  
)

export default component.exports